function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import NumberTextInput from '../number-text';
import { pickValidValues } from '../../../helpers/components-helpers';

class CurrencyInput extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "_beforeMaskedValueChange", (newState, oldState) => {
      if (!newState.value) {
        return newState;
      }

      var {
        value: oldValue,
        selection: oldSelection
      } = oldState;
      var {
        value: newValue,
        selection: newSelection
      } = newState;
      var modifiedState = {
        value: "$".concat(this._formatCurrency(newValue)),
        selection: newSelection
      };
      var oldFormattedValue = "$".concat(this._formatCurrency(oldValue));
      var newFormattedValue = "$".concat(this._formatCurrency(newValue));

      if (oldSelection && newSelection && oldFormattedValue !== newFormattedValue) {
        var valueLengthDifference = newFormattedValue.length - oldFormattedValue.length;

        if (modifiedState.selection && Math.abs(valueLengthDifference) > 1) {
          modifiedState.selection = {
            start: oldSelection.start + valueLengthDifference,
            end: oldSelection.end + valueLengthDifference
          };
        }
      }

      return modifiedState;
    });
  }

  _formatCurrency(value) {
    // https://stackoverflow.com/questions/14751802/split-string-every-3-characters-from-back-using-javascript
    // Split in chunks of 3 "thousands" and join with ','
    var numberFormat = value.replace(/[$,]/g, '');
    var [dollars, cents] = numberFormat.split('.');
    var formattedDollarAmt = dollars.split(/(?=(?:...)*$)/).join(',');
    return "".concat(formattedDollarAmt).concat(cents !== undefined ? ".".concat(cents.substring(0, 2)) : '');
  }

  _modifyWithDefaultOptions() {
    var {
      options
    } = this.props;
    var optionsWithValidValue = pickValidValues(options);
    return _objectSpread(_objectSpread({}, this.props), {}, {
      options: Object.assign({
        pattern: '^\\d+$|^\\d+\\.{1}\\d{1,2}$',
        mask: '$ccccccccccccccccc',
        returnUnmaskedValue: true
      }, optionsWithValidValue)
    });
  }

  render() {
    var modifiedProps = this._modifyWithDefaultOptions(); // type text is required because type number' does not support selection


    return /*#__PURE__*/React.createElement(NumberTextInput, _extends({}, modifiedProps, {
      beforeMaskedValueChange: this._beforeMaskedValueChange
    }));
  }

}

_defineProperty(CurrencyInput, "defaultProps", {
  options: {}
});

export default CurrencyInput;